
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iiPY2", function(module, exports) {
$parcel$export(module.exports, "ContentTypeClassification", () => (parcelRequire("2JKSZ")).ContentTypeClassification);

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");


var $2JKSZ = parcelRequire("2JKSZ");


const $200528ba24c995ad$export$b3d0b57fae17761b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fcpuS",
    name: "ContentTypeClassificationLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("2JKSZ")))).ContentTypeClassification,
    loading: (props)=>{
        const { contentClassificationMetadata: contentClassificationMetadata } = props;
        const { hasNoClassification: hasNoClassification } = contentClassificationMetadata;
        const shouldNotRenderLoader = hasNoClassification;
        if (shouldNotRenderLoader) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
            const $ = (0, $frIzR.c)(13);
            let T0;
            let t1;
            let t2;
            let t3;
            let t4;
            if ($[0] !== __cmplr || $[1] !== t0) {
                const { as: t5, style: __cmpls, ...__cmplp } = t0;
                const C = t5 === undefined ? "div" : t5;
                T0 = C;
                t1 = __cmplp;
                t2 = __cmpls;
                t3 = __cmplr;
                t4 = (0, $gMc0m.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ]);
                $[0] = __cmplr;
                $[1] = t0;
                $[2] = T0;
                $[3] = t1;
                $[4] = t2;
                $[5] = t3;
                $[6] = t4;
            } else {
                T0 = $[2];
                t1 = $[3];
                t2 = $[4];
                t3 = $[5];
                t4 = $[6];
            }
            let t5;
            if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
                    ...t1,
                    style: t2,
                    ref: t3,
                    className: t4
                });
                $[7] = T0;
                $[8] = t1;
                $[9] = t2;
                $[10] = t3;
                $[11] = t4;
                $[12] = t5;
            } else t5 = $[12];
            return t5;
        } : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $gMc0m.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});
module.exports["ContentTypeClassificationLoader"] = $200528ba24c995ad$export$b3d0b57fae17761b;

});

parcelRegister("2JKSZ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $arfOv = parcelRequire("arfOv");


var $9yVdT = parcelRequire("9yVdT");


var $fGQzQ = parcelRequire("fGQzQ");


var $1u6lx = parcelRequire("1u6lx");


var $in5LX = parcelRequire("in5LX");


var $79yie = parcelRequire("79yie");


var $1cYlh = parcelRequire("1cYlh");


const $d07cae14ea38bbbf$var$ClassificationTagButtonError = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8ozBk",
    name: "ClassificationTagButtonError",
    loader: async ()=>(await (parcelRequire("1gG4q"))).ClassificationTagButtonError
});
const $d07cae14ea38bbbf$var$ContentTypeClassificationComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: t1, variant: t2, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId } = t0;
    const readOnly = t1 === undefined ? true : t1;
    const variant = t2 === undefined ? (0, $1u6lx.TagButtonUIVariant).default : t2;
    const intl = (0, $aXWIB.useIntl)();
    let t3;
    if ($[0] !== contentClassificationMetadata || $[1] !== contentId) {
        t3 = {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata
        };
        $[0] = contentClassificationMetadata;
        $[1] = contentId;
        $[2] = t3;
    } else t3 = $[2];
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)(t3);
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const showNoClassificationLozenge = contentClassificationMetadata?.userOverrideSetting === "DISALLOW" && hasNoClassification && (0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification && !showNoClassificationLozenge;
    if (isAddNewClassificationMode) return null;
    let displayClassification = currentClassification;
    if (showNoClassificationLozenge) {
        let t4;
        if ($[3] !== intl.formatMessage) {
            t4 = (0, $1cYlh.getNoClassificationForContent)(intl.formatMessage);
            $[3] = intl.formatMessage;
            $[4] = t4;
        } else t4 = $[4];
        displayClassification = t4;
    }
    if (!displayClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) {
        let t4;
        if ($[5] !== contentLevelError) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
                contentLevelError: contentLevelError
            });
            $[5] = contentLevelError;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const t4 = readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit;
    let t5;
    if ($[7] !== buttonTestId || $[8] !== canManageSpaceSettings || $[9] !== classificationControlSetting || $[10] !== contentId || $[11] !== contentType || $[12] !== displayClassification || $[13] !== handleSubmit || $[14] !== isLoading || $[15] !== onRestoreFocus || $[16] !== popupPlacementOverride || $[17] !== source || $[18] !== spaceDefaultIsOverridden || $[19] !== spaceKey || $[20] !== spacing || $[21] !== t4 || $[22] !== userOverrideSetting || $[23] !== variant) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arfOv.GenericClassificationTagButton), {
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: contentType,
            currentClassification: displayClassification,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            onEditSubmit: handleSubmit,
            menuBehavior: t4,
            loading: isLoading,
            variant: variant,
            popupPlacementOverride: popupPlacementOverride,
            spacing: spacing,
            onRestoreFocus: onRestoreFocus,
            buttonTestId: buttonTestId,
            source: source,
            canManageSpaceSettings: canManageSpaceSettings,
            classificationControlSetting: classificationControlSetting,
            userOverrideSetting: userOverrideSetting
        });
        $[7] = buttonTestId;
        $[8] = canManageSpaceSettings;
        $[9] = classificationControlSetting;
        $[10] = contentId;
        $[11] = contentType;
        $[12] = displayClassification;
        $[13] = handleSubmit;
        $[14] = isLoading;
        $[15] = onRestoreFocus;
        $[16] = popupPlacementOverride;
        $[17] = source;
        $[18] = spaceDefaultIsOverridden;
        $[19] = spaceKey;
        $[20] = spacing;
        $[21] = t4;
        $[22] = userOverrideSetting;
        $[23] = variant;
        $[24] = t5;
    } else t5 = $[24];
    let t6;
    if ($[25] !== flagStatus || $[26] !== isLoading || $[27] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
            isLoading: isLoading,
            flagStatus: flagStatus
        }, t5);
        $[25] = flagStatus;
        $[26] = isLoading;
        $[27] = t5;
        $[28] = t6;
    } else t6 = $[28];
    return t6;
} : ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: readOnly = true, variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const showNoClassificationLozenge = contentClassificationMetadata?.userOverrideSetting === 'DISALLOW' && hasNoClassification && (0, $6mKj3.expVal)('dlp_auto_classifications_enabled', 'isEnabled', false);
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification && !showNoClassificationLozenge;
    if (isAddNewClassificationMode) return null;
    let displayClassification = currentClassification;
    if (showNoClassificationLozenge) displayClassification = (0, $1cYlh.getNoClassificationForContent)(intl.formatMessage);
    if (!displayClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
        contentLevelError: contentLevelError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
        isLoading: isLoading,
        flagStatus: flagStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arfOv.GenericClassificationTagButton), {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        currentClassification: displayClassification,
        spaceDefaultIsOverridden: spaceDefaultIsOverridden,
        onEditSubmit: handleSubmit,
        menuBehavior: readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit,
        loading: isLoading,
        variant: variant,
        popupPlacementOverride: popupPlacementOverride,
        spacing: spacing,
        onRestoreFocus: onRestoreFocus,
        buttonTestId: buttonTestId,
        source: source,
        canManageSpaceSettings: canManageSpaceSettings,
        classificationControlSetting: classificationControlSetting,
        userOverrideSetting: userOverrideSetting
    }));
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationGetter = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($d07cae14ea38bbbf$var$ContentTypeClassificationGetter);
const $d07cae14ea38bbbf$export$e97138dbbe0f9a02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
module.exports["ContentTypeClassification"] = $d07cae14ea38bbbf$export$e97138dbbe0f9a02;

});

parcelRegister("arfOv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $i2BsV = parcelRequire("i2BsV");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $earLp = parcelRequire("earLp");


var $1u6lx = parcelRequire("1u6lx");


var $6Ry4r = parcelRequire("6Ry4r");


const $e299f5faef060d8a$var$ClassificationReadViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "zUIer",
    name: "ClassificationReadViewPopup",
    loader: async ()=>(await (parcelRequire("ddDB2"))).ClassificationReadViewPopup
});

const $e299f5faef060d8a$var$ClassificationEditViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mT5oW",
    name: "ClassificationEditViewPopup",
    loader: async ()=>(await (parcelRequire("kGmHz"))).ClassificationEditViewPopup
});
var $e299f5faef060d8a$export$db79e28c55608769 = /*#__PURE__*/ function(TagButtonMenuBehavior) {
    TagButtonMenuBehavior["readOnly"] = "readOnly";
    TagButtonMenuBehavior["editOnly"] = "editOnly";
    TagButtonMenuBehavior["readAndEdit"] = "readAndEdit";
    return TagButtonMenuBehavior;
}({});
const $e299f5faef060d8a$var$DataClassificationLevelMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $i2BsV.default));
const $e299f5faef060d8a$var$messages = (0, $aXWIB.defineMessages)({
    tooltipMessage: {
        id: "data-classification.content-classification.tag-button.tooltip",
        defaultMessage: "This {contentType} is classified as {classification}"
    }
});
const $e299f5faef060d8a$export$e396cc9924b8f3a0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(56);
    const { spaceKey: spaceKey, contentId: contentId, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: t1, isPopupDisabled: t2, menuBehavior: t3, variant: t4, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: t5, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = t0;
    const loading = t1 === undefined ? false : t1;
    const isPopupDisabled = t2 === undefined ? false : t2;
    const menuBehavior = t3 === undefined ? "readOnly" : t3;
    const variant = t4 === undefined ? (0, $1u6lx.TagButtonUIVariant).default : t4;
    const buttonTestId = t5 === undefined ? "data-classification-level" : t5;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isReadView, setIsReadView] = (0, $42omo.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || "auto";
    let t6;
    let t7;
    if ($[0] !== menuBehavior) {
        t6 = ()=>{
            if (menuBehavior === "editOnly") setIsReadView(false);
        };
        t7 = [
            menuBehavior
        ];
        $[0] = menuBehavior;
        $[1] = t6;
        $[2] = t7;
    } else {
        t6 = $[1];
        t7 = $[2];
    }
    (0, $42omo.useEffect)(t6, t7);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    let getOnChangeLevelClick;
    let handlePopupShown;
    let onEditCancel;
    let onEditSubmit;
    if ($[3] !== isReadView || $[4] !== menuBehavior || $[5] !== onEditCancelProp || $[6] !== onEditSubmitProp || $[7] !== onRestoreFocus || $[8] !== trackEditPopupViewed) {
        getOnChangeLevelClick = ()=>{
            if (menuBehavior === "readOnly") return;
            return ()=>{
                setIsReadView(false);
                handlePopupShown({
                    isOpen: true,
                    shouldForce: true
                });
            };
        };
        let t8;
        if ($[13] !== menuBehavior || $[14] !== onEditCancelProp) {
            t8 = (closePopup)=>{
                onEditCancelProp && onEditCancelProp();
                closePopup();
                if (menuBehavior !== "editOnly") setIsReadView(true);
            };
            $[13] = menuBehavior;
            $[14] = onEditCancelProp;
            $[15] = t8;
        } else t8 = $[15];
        onEditCancel = t8;
        let t9;
        if ($[16] !== menuBehavior || $[17] !== onEditSubmitProp || $[18] !== onRestoreFocus) {
            t9 = (classification, closePopup_0)=>{
                onEditSubmitProp && onEditSubmitProp(classification);
                onRestoreFocus && onRestoreFocus();
                closePopup_0();
                if (menuBehavior !== "editOnly") setIsReadView(true);
            };
            $[16] = menuBehavior;
            $[17] = onEditSubmitProp;
            $[18] = onRestoreFocus;
            $[19] = t9;
        } else t9 = $[19];
        onEditSubmit = t9;
        handlePopupShown = (t10)=>{
            const { isOpen: isOpen, shouldForce: t11 } = t10;
            const shouldForce = t11 === undefined ? false : t11;
            if (isOpen) {
                const shouldTrackEvent = !isReadView || shouldForce;
                if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
            }
        };
        $[3] = isReadView;
        $[4] = menuBehavior;
        $[5] = onEditCancelProp;
        $[6] = onEditSubmitProp;
        $[7] = onRestoreFocus;
        $[8] = trackEditPopupViewed;
        $[9] = getOnChangeLevelClick;
        $[10] = handlePopupShown;
        $[11] = onEditCancel;
        $[12] = onEditSubmit;
    } else {
        getOnChangeLevelClick = $[9];
        handlePopupShown = $[10];
        onEditCancel = $[11];
        onEditSubmit = $[12];
    }
    let t8;
    if ($[20] !== canManageSpaceSettings || $[21] !== classificationControlSetting || $[22] !== cloudId || $[23] !== contentId || $[24] !== currentClassification || $[25] !== defaultSelectedEditOption || $[26] !== getOnChangeLevelClick || $[27] !== isReadView || $[28] !== loading || $[29] !== onEditCancel || $[30] !== onEditSubmit || $[31] !== source || $[32] !== spaceKey || $[33] !== userOverrideSetting) {
        t8 = (closePopup_1)=>isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
                name: currentClassification.name,
                classification: currentClassification,
                onChangeLevelClick: getOnChangeLevelClick(),
                source: source ?? undefined,
                isCurrentUserSpaceAdmin: canManageSpaceSettings,
                classificationControl: classificationControlSetting ?? "ANY",
                userOverride: userOverrideSetting ?? "ANY"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
                spaceKey: spaceKey,
                selectedOption: defaultSelectedEditOption,
                onEditCancel: ()=>onEditCancel(closePopup_1),
                onEditSubmit: (classification_0)=>onEditSubmit(classification_0, closePopup_1),
                loading: loading,
                cloudId: cloudId,
                contentId: contentId,
                userOverride: userOverrideSetting ?? "ANY"
            });
        $[20] = canManageSpaceSettings;
        $[21] = classificationControlSetting;
        $[22] = cloudId;
        $[23] = contentId;
        $[24] = currentClassification;
        $[25] = defaultSelectedEditOption;
        $[26] = getOnChangeLevelClick;
        $[27] = isReadView;
        $[28] = loading;
        $[29] = onEditCancel;
        $[30] = onEditSubmit;
        $[31] = source;
        $[32] = spaceKey;
        $[33] = userOverrideSetting;
        $[34] = t8;
    } else t8 = $[34];
    const renderPopupComponent = t8;
    let t9;
    if ($[35] !== currentClassification) {
        t9 = (0, $6Ry4r.getGuidelineProps)(currentClassification);
        $[35] = currentClassification;
        $[36] = t9;
    } else t9 = $[36];
    const { guideline: guideline, guidelineRepresentation: guidelineRepresentation } = t9;
    const t10 = currentClassification.name;
    let t11;
    if ($[37] !== contentType || $[38] !== currentClassification.name || $[39] !== formatMessage) {
        t11 = formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        });
        $[37] = contentType;
        $[38] = currentClassification.name;
        $[39] = formatMessage;
        $[40] = t11;
    } else t11 = $[40];
    const t12 = currentClassification.color || "GREY";
    const t13 = renderPopupComponent;
    let t14;
    if ($[41] !== handlePopupShown) {
        t14 = ()=>handlePopupShown({
                isOpen: true
            });
        $[41] = handlePopupShown;
        $[42] = t14;
    } else t14 = $[42];
    const t15 = variant === (0, $1u6lx.TagButtonUIVariant).iconOnly;
    let t16;
    if ($[43] !== buttonTestId || $[44] !== currentClassification.name || $[45] !== guideline || $[46] !== guidelineRepresentation || $[47] !== isPopupDisabled || $[48] !== popupPlacement || $[49] !== spacing || $[50] !== t11 || $[51] !== t12 || $[52] !== t13 || $[53] !== t14 || $[54] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
            testId: buttonTestId,
            name: t10,
            guideline: guideline,
            guidelineRepresentation: guidelineRepresentation,
            tooltip: t11,
            color: t12,
            isPopupDisabled: isPopupDisabled,
            renderPopupComponent: t13,
            onPopupShown: t14,
            isIconOnly: t15,
            popupPlacement: popupPlacement,
            spacing: spacing
        }));
        $[43] = buttonTestId;
        $[44] = currentClassification.name;
        $[45] = guideline;
        $[46] = guidelineRepresentation;
        $[47] = isPopupDisabled;
        $[48] = popupPlacement;
        $[49] = spacing;
        $[50] = t11;
        $[51] = t12;
        $[52] = t13;
        $[53] = t14;
        $[54] = t15;
        $[55] = t16;
    } else t16 = $[55];
    return t16;
} : ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: loading = false, isPopupDisabled: isPopupDisabled = false, menuBehavior: menuBehavior = "readOnly", variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId = 'data-classification-level', source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isReadView, setIsReadView] = (0, $42omo.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || 'auto';
    (0, $42omo.useEffect)(()=>{
        if (menuBehavior === "editOnly") setIsReadView(false);
    }, [
        menuBehavior
    ]);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    const getOnChangeLevelClick = ()=>{
        if (menuBehavior === "readOnly") return undefined;
        return ()=>{
            setIsReadView(false);
            handlePopupShown({
                isOpen: true,
                shouldForce: true
            });
        };
    };
    const onEditCancel = (closePopup)=>{
        onEditCancelProp && onEditCancelProp();
        closePopup();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const onEditSubmit = (classification, closePopup_0)=>{
        onEditSubmitProp && onEditSubmitProp(classification);
        onRestoreFocus && onRestoreFocus();
        closePopup_0();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const handlePopupShown = ({ isOpen: isOpen, shouldForce: shouldForce = false })=>{
        if (isOpen) {
            const shouldTrackEvent = !isReadView || shouldForce;
            if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
        }
    };
    const renderPopupComponent = (closePopup_1)=>{
        return isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
            name: currentClassification.name,
            classification: currentClassification,
            onChangeLevelClick: getOnChangeLevelClick(),
            source: source ?? undefined,
            isCurrentUserSpaceAdmin: canManageSpaceSettings,
            classificationControl: classificationControlSetting ?? 'ANY',
            userOverride: userOverrideSetting ?? 'ANY'
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
            spaceKey: spaceKey,
            selectedOption: defaultSelectedEditOption,
            onEditCancel: ()=>onEditCancel(closePopup_1),
            onEditSubmit: (classification_0)=>onEditSubmit(classification_0, closePopup_1),
            loading: loading,
            cloudId: cloudId,
            contentId: contentId,
            userOverride: userOverrideSetting ?? 'ANY'
        });
    };
    const { guideline: guideline, guidelineRepresentation: guidelineRepresentation } = (0, $6Ry4r.getGuidelineProps)(currentClassification);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
        testId: buttonTestId,
        name: currentClassification.name,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation,
        tooltip: formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        }),
        color: currentClassification.color || 'GREY',
        isPopupDisabled: isPopupDisabled,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        renderPopupComponent: renderPopupComponent,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        onPopupShown: ()=>handlePopupShown({
                isOpen: true
            }),
        isIconOnly: variant === (0, $1u6lx.TagButtonUIVariant).iconOnly,
        popupPlacement: popupPlacement,
        spacing: spacing
    }));
};
module.exports["TagButtonMenuBehavior"] = $e299f5faef060d8a$export$db79e28c55608769;
module.exports["GenericClassificationTagButton"] = $e299f5faef060d8a$export$e396cc9924b8f3a0;

});

parcelRegister("1u6lx", function(module, exports) {
var $a200b44450c31008$export$f72f271864b318ce = /*#__PURE__*/ function(TagButtonUIVariant) {
    TagButtonUIVariant["iconOnly"] = "iconOnly";
    TagButtonUIVariant["default"] = "default";
    return TagButtonUIVariant;
}({});
module.exports["TagButtonUIVariant"] = $a200b44450c31008$export$f72f271864b318ce;

});

parcelRegister("ddDB2", function(module, exports) {

let $027bcb2a62b71cce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $027bcb2a62b71cce$var$load("iJsKa").then(()=>parcelRequire('ePhVt'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("kGmHz", function(module, exports) {

let $f0e956f9b8b5df56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0e956f9b8b5df56$var$load("cZdQT"),
    $f0e956f9b8b5df56$var$load("58UdM")
]).then(()=>parcelRequire('8KSlr'));

});

parcelRegister("9yVdT", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $9hlns = parcelRequire("9hlns");


var $u9agA = parcelRequire("u9agA");


var $gqqjz = parcelRequire("gqqjz");


var $in5LX = parcelRequire("in5LX");


var $gfkT8 = parcelRequire("gfkT8");


var $93WhG = parcelRequire("93WhG");

const $b9673e4989b5dd09$export$10b01f6c9dc571ea = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children, flagStatus: flagStatus, isLoading: t1 } = t0;
    const isLoading = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isLoading) {
        t2 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small",
            interactionName: "data-classification-tag-loading"
        });
        $[0] = isLoading;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== flagStatus) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t3
        }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfkT8.SaveFlag), {
                flags: flags,
                title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
                description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
                type: "warning",
                showRefresh: false
            }));
        $[3] = flagStatus;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== children || $[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050"
        }, children, t2, t4);
        $[5] = children;
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ children: children, flagStatus: flagStatus, isLoading: isLoading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small",
        interactionName: "data-classification-tag-loading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfkT8.SaveFlag), {
            flags: flags,
            title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
            description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
            type: "warning",
            showRefresh: false
        })));
};
module.exports["TagLoadingAndFlagWrapper"] = $b9673e4989b5dd09$export$10b01f6c9dc571ea;

});

parcelRegister("fGQzQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7tHGa = parcelRequire("7tHGa");


var $in5LX = parcelRequire("in5LX");


var $4oYaK = parcelRequire("4oYaK");


var $3tzmY = parcelRequire("3tzmY");


var $45d60 = parcelRequire("45d60");


var $fcQxC = parcelRequire("fcQxC");

const $3ebf4e9018306b37$export$9756cece5bf0eb59 = (contentStatus)=>{
    switch(contentStatus){
        case (0, $7tHGa.ContentStatus).DRAFT:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).DRAFT;
        default:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).CURRENT;
    }
};
const $3ebf4e9018306b37$export$94cbb2414d06bc8b = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { contentId: contentId, contentClassificationMetadata: contentClassificationMetadata } = t0;
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    let t1;
    if ($[0] !== contentId || $[1] !== contentStatusContext || $[2] !== deleteClassificationMutation || $[3] !== setFlagStatus || $[4] !== setSubmittedClassification || $[5] !== updateClassificationMutation) {
        t1 = (classificationOption)=>{
            if (!classificationOption?.id) return;
            setFlagStatus((0, $in5LX.FlagStatus).LOADING);
            const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? "current-only");
            const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
            const baseVariables = {
                id: parseInt(contentId),
                contentStatuses: contentStatuses
            };
            const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
            const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
            const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
            if (shouldDeleteClassification) {
                if (optionIsNoClassificationOption) setSubmittedClassification(null);
                if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
                deleteClassificationMutation({
                    variables: baseVariables
                });
            } else {
                setSubmittedClassification(classificationOption);
                updateClassificationMutation({
                    variables: {
                        ...baseVariables,
                        classificationLevelId: classificationOption.id
                    }
                });
            }
        };
        $[0] = contentId;
        $[1] = contentStatusContext;
        $[2] = deleteClassificationMutation;
        $[3] = setFlagStatus;
        $[4] = setSubmittedClassification;
        $[5] = updateClassificationMutation;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ contentId: contentId, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    return (0, $42omo.useCallback)((classificationOption)=>{
        // Provides type safety for the mutation variables
        if (!classificationOption?.id) return;
        setFlagStatus((0, $in5LX.FlagStatus).LOADING);
        const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? 'current-only');
        const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
        const baseVariables = {
            id: parseInt(contentId),
            contentStatuses: contentStatuses
        };
        const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
        const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
        const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
        if (shouldDeleteClassification) {
            if (optionIsNoClassificationOption) setSubmittedClassification(null);
            if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
            deleteClassificationMutation({
                variables: baseVariables
            });
        } else {
            setSubmittedClassification(classificationOption);
            updateClassificationMutation({
                variables: {
                    ...baseVariables,
                    classificationLevelId: classificationOption.id
                }
            });
        }
    }, [
        contentId,
        setFlagStatus,
        contentStatusContext,
        updateClassificationMutation,
        deleteClassificationMutation,
        setSubmittedClassification
    ]);
};
module.exports["useEditSubmitCallback"] = $3ebf4e9018306b37$export$94cbb2414d06bc8b;

});

parcelRegister("4oYaK", function(module, exports) {
const $8d28ed91f3c96188$export$ea52aaec0b4536b2 = 'data-classification.no-classification-option';
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $8d28ed91f3c96188$export$ea52aaec0b4536b2;

});

parcelRegister("3tzmY", function(module, exports) {
const $1cdd6556a0b2e638$export$8942d0d7876f8b98 = 'data-classification.space-default-classification-option';
module.exports["SPACE_DEFAULT_CLASSIFICATION_OPTION_ID"] = $1cdd6556a0b2e638$export$8942d0d7876f8b98;

});

parcelRegister("45d60", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d94436a169325872$export$8be450ac125d65b9 = /*#__PURE__*/ function(ContentDataClassificationMutationContentStatus) {
    ContentDataClassificationMutationContentStatus["CURRENT"] = "CURRENT";
    ContentDataClassificationMutationContentStatus["DRAFT"] = "DRAFT";
    return ContentDataClassificationMutationContentStatus;
}({});
module.exports["ContentDataClassificationMutationContentStatus"] = $d94436a169325872$export$8be450ac125d65b9;

});

parcelRegister("1gG4q", function(module, exports) {

let $0ec7eb59ea45e0fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ec7eb59ea45e0fc$var$load("5odbj").then(()=>parcelRequire('2O7oS'));

});

parcelRegister("knzfV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $40pD8 = parcelRequire("40pD8");


var $fGQzQ = parcelRequire("fGQzQ");


var $earLp = parcelRequire("earLp");


const $5cd13874f5033207$var$LazyClassificationEditModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "oT96U",
    name: "LazyClassificationEditModalContent",
    loader: async ()=>(await (parcelRequire("ctS5p"))).ClassificationEditModalContent
});
const $5cd13874f5033207$export$d7e008c8afea1e79 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata } = t0;
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    let t1;
    if ($[0] !== contentClassificationMetadata || $[1] !== contentId) {
        t1 = {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata
        };
        $[0] = contentClassificationMetadata;
        $[1] = contentId;
        $[2] = t1;
    } else t1 = $[2];
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)(t1);
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    let t2;
    if ($[3] !== handleSubmit || $[4] !== setIsClassificationModalOpen) {
        t2 = (classificationOption)=>{
            handleSubmit(classificationOption);
            setIsClassificationModalOpen(false);
        };
        $[3] = handleSubmit;
        $[4] = setIsClassificationModalOpen;
        $[5] = t2;
    } else t2 = $[5];
    const onEditSubmit = t2;
    let t3;
    if ($[6] !== setIsClassificationModalOpen) {
        t3 = ()=>{
            setIsClassificationModalOpen(false);
        };
        $[6] = setIsClassificationModalOpen;
        $[7] = t3;
    } else t3 = $[7];
    const onEditCancel = t3;
    let t4;
    let t5;
    if ($[8] !== isClassificationModalOpen || $[9] !== trackEditPopupViewed) {
        t4 = ()=>{
            if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
        };
        t5 = [
            isClassificationModalOpen,
            trackEditPopupViewed
        ];
        $[8] = isClassificationModalOpen;
        $[9] = trackEditPopupViewed;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $42omo.useEffect)(t4, t5);
    if (!isClassificationModalOpen) return null;
    let t6;
    if ($[12] !== setIsClassificationModalOpen) {
        t6 = ()=>setIsClassificationModalOpen(false);
        $[12] = setIsClassificationModalOpen;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = defaultSelectedEditOption ?? undefined;
    let t8;
    if ($[14] !== contentId || $[15] !== onEditCancel || $[16] !== onEditSubmit || $[17] !== spaceKey || $[18] !== t6 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cd13874f5033207$var$LazyClassificationEditModalContent, {
            onClose: t6,
            onEditSubmit: onEditSubmit,
            onEditCancel: onEditCancel,
            selectedOption: t7,
            spaceKey: spaceKey,
            contentId: contentId
        });
        $[14] = contentId;
        $[15] = onEditCancel;
        $[16] = onEditSubmit;
        $[17] = spaceKey;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    const onEditSubmit = (0, $42omo.useCallback)((classificationOption)=>{
        handleSubmit(classificationOption);
        setIsClassificationModalOpen(false);
    }, [
        handleSubmit,
        setIsClassificationModalOpen
    ]);
    const onEditCancel = (0, $42omo.useCallback)(()=>{
        setIsClassificationModalOpen(false);
    }, [
        setIsClassificationModalOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
    }, [
        isClassificationModalOpen,
        trackEditPopupViewed
    ]);
    if (!isClassificationModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cd13874f5033207$var$LazyClassificationEditModalContent, {
        onClose: ()=>setIsClassificationModalOpen(false),
        onEditSubmit: onEditSubmit,
        onEditCancel: onEditCancel,
        selectedOption: defaultSelectedEditOption ?? undefined,
        spaceKey: spaceKey,
        contentId: contentId
    });
};
module.exports["ClassificationEditModal"] = $5cd13874f5033207$export$d7e008c8afea1e79;

});

parcelRegister("ctS5p", function(module, exports) {

let $916225d9cb0b81df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $916225d9cb0b81df$var$load("cZdQT"),
    $916225d9cb0b81df$var$load("58UdM"),
    $916225d9cb0b81df$var$load("20qsp")
]).then(()=>parcelRequire('enSER'));

});

parcelRegister("cuWTe", function(module, exports) {
const $52d439f2e3e46670$export$5d6b4e71896e8f23 = (contentType, isArchived, isDraft, isViewEditOrLive)=>{
    // archived takes priority, since other modes like 'view' can be in this state
    if (isArchived) return 'archived';
    // useGetPageMode *always* returns one of 'live', 'view', or 'edit', but these modes don't apply across all
    // content types - so the content type doesn't have a 'mode' and we should return undefined
    if (contentType === 'page' || contentType === 'blogpost') {
        // then draft takes next priority, since other modes like 'edit' can be in this state
        if (isDraft) return 'draft';
        // technically only pages can be live at the moment, and blogposts wouldn't ever return live, but they *could*
        return isViewEditOrLive;
    } else return undefined;
};
module.exports["getContentMode"] = $52d439f2e3e46670$export$5d6b4e71896e8f23;

});

parcelRegister("iAOfI", function(module, exports) {

var $4YBSq = parcelRequire("4YBSq");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $9hlns = parcelRequire("9hlns");


var $1iSzD = parcelRequire("1iSzD");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $gkIgp = parcelRequire("gkIgp");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $7aRa9 = parcelRequire("7aRa9");


var $3u7PM = parcelRequire("3u7PM");


var $c4cfx = parcelRequire("c4cfx");


var $7mHcA = parcelRequire("7mHcA");

const $25b07369982b4436$var$EditContentButtonQuery = (0, $4YBSq.default);
const $25b07369982b4436$var$EditContentButtonInner = (0, $7aRa9.withFlags)(({ flags: flags, contentId: contentId, isCompanyHubButton: isCompanyHubButton, ...passThroughProps })=>{
    const { epMigrationOnLoad: epMigrationOnLoad, epMigrationOnClick: epMigrationOnClick } = (0, $7mHcA.useEmbeddedMigrationQuery)(contentId, true);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($25b07369982b4436$var$EditContentButtonQuery, {
        variables: {
            contentId: contentId
        },
        // cache-and-network is required to ensure that the edit button is rendered immediately after page publish
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "@confluence/edit-button"
    });
    const { data: epMigrationOnLoadData, loading: epMigrationOnLoadLoading, error: epMigrationOnLoadError } = epMigrationOnLoad;
    const { migrateEPData: migrateEPData, data: epMigrationOnClickData, loading: epMigrationOnClickLoading, error: epMigrationOnClickError } = epMigrationOnClick;
    const { showNoEditAccessFlag: showNoEditAccessFlag } = (0, $3u7PM.useNoEditAccessFlag)(flags);
    let renderedEditContentButton;
    if (error) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    else if (!data && loading || !epMigrationOnLoadData && epMigrationOnLoadLoading || !epMigrationOnClickData && epMigrationOnClickLoading) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: "edit-content-button",
        size: "small"
    });
    else {
        const contentNode = data?.content?.nodes?.[0];
        const operations = contentNode?.operations ?? [];
        const contentType = contentNode?.type ?? undefined;
        const canEdit = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
        if (!canEdit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.EDIT_SHORTCUT),
            listener: showNoEditAccessFlag
        });
        const spaceKey = data?.content?.nodes?.[0]?.space?.key ?? undefined;
        const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
        const isFabricSupported = metadataFrontend?.fabricEditorSupported ?? false;
        const isNCSContent = metadataFrontend?.collabService === (0, $gkIgp.CollabServiceProperty).NCS;
        // 'edit-embed' route (embedded editor) should only be used inside parent product and when page is ncs
        const isEmbeddedContent = ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && isNCSContent) ?? false;
        const embeddedMigrationError = epMigrationOnLoadError || epMigrationOnClickError;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, embeddedMigrationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: embeddedMigrationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4cfx.EditContentButtonComponent), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            isCompanyHubButton: isCompanyHubButton,
            isFabricSupported: isFabricSupported,
            isEmbeddedContent: isEmbeddedContent,
            migrateEPData: !isNCSContent ? migrateEPData : undefined,
            ...passThroughProps
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
    }), renderedEditContentButton);
});
const $25b07369982b4436$export$3df6d768aebb677f = /*#__PURE__*/ (0, $42omo.memo)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($25b07369982b4436$var$EditContentButtonInner));
$25b07369982b4436$export$3df6d768aebb677f.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onRender: (0, $c4cfx.EditContentButtonComponent).propTypes?.onRender
};
module.exports["EditContentButton"] = $25b07369982b4436$export$3df6d768aebb677f;

});

parcelRegister("c4cfx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $jTxSS = parcelRequire("jTxSS");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $1Zr9M = parcelRequire("1Zr9M");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $iFjdQ = parcelRequire("iFjdQ");


var $5q601 = parcelRequire("5q601");


var $74Lca = parcelRequire("74Lca");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $emYzJ = parcelRequire("emYzJ");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $39rFu = parcelRequire("39rFu");


var $7NoF3 = parcelRequire("7NoF3");


var $4ri4I = parcelRequire("4ri4I");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");


var $4o1RV = parcelRequire("4o1RV");


var $de2j9 = parcelRequire("de2j9");


var $hl1Kw = parcelRequire("hl1Kw");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $lqy4C = parcelRequire("lqy4C");


var $sD2Tz = parcelRequire("sD2Tz");


var $ca2z9 = parcelRequire("ca2z9");

const $a4b894acf4b5251f$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $4KS7f.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_701w1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a4b894acf4b5251f$var$i18n = (0, $aXWIB.defineMessages)({
    editLabel: {
        id: "edit-button.edit.label",
        defaultMessage: "Edit this content"
    },
    editEmbedLabel: {
        id: "edit-button.edit.embed.label",
        defaultMessage: "Edit this embed"
    },
    editText: {
        id: "edit-button.edit.text",
        defaultMessage: "Edit"
    }
});
const $a4b894acf4b5251f$var$noop = ()=>null;
const $a4b894acf4b5251f$var$EditContentButtonComponentInner = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(117);
    const { contentId: contentId, contentType: contentType, intl: intl, isEmbeddedContent: t1, isFabricSupported: isFabricSupported, onRender: t2, spaceKey: spaceKey, migrateEPData: migrateEPData, isCompanyHubButton: t3 } = t0;
    const isEmbeddedContent = t1 === undefined ? false : t1;
    const onRender = t2 === undefined ? $a4b894acf4b5251f$var$noop : t2;
    const isCompanyHubButton = t3 === undefined ? false : t3;
    const editButtonRef = (0, $42omo.useRef)(null);
    const [localEditSource, setLocalEditSource] = (0, $42omo.useState)("");
    const [isPopupVisible, setIsPopupVisible] = (0, $42omo.useState)(false);
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t4;
    if ($[0] !== createAnalyticsEvent) {
        t4 = (action, analyticsContentId, attributes)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: action,
                    actionSubject: "editButtonCollabDraftPrefetch",
                    actionSubjectId: analyticsContentId,
                    source: "editButton",
                    attributes: attributes
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t4;
    } else t4 = $[1];
    const sendPrefetchAnalyticsEvent = t4;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [t5] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics } = t5;
    const { match: match } = routesContext;
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            source: "page-tree-quick-action-edit"
        };
        $[2] = t6;
    } else t6 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t6);
    let t7;
    if ($[3] !== contentId || $[4] !== isFabricSupported) {
        t7 = {
            contentId: contentId,
            isFabricSupported: isFabricSupported
        };
        $[3] = contentId;
        $[4] = isFabricSupported;
        $[5] = t7;
    } else t7 = $[5];
    const { fabricEditorEligibility: fabricEditorEligibility, isFabricEligibilityLoading: isFabricEligibilityLoading } = (0, $ca2z9.useFabricEligibilityMigrationQuery)(t7);
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            shortcut: (0, $gnkil.EDIT_SHORTCUT)
        };
        $[6] = t8;
    } else t8 = $[6];
    const editShortcutStrings = (0, $4tOXV.useShortcutStrings)(t8);
    const currentRouteName = match?.name;
    const isBlogpost = contentType === "blogpost";
    const t9 = isBlogpost ? "blog" : "pages";
    let t10;
    if ($[7] !== contentId || $[8] !== spaceKey || $[9] !== t9) {
        t10 = {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: t9
        };
        $[7] = contentId;
        $[8] = spaceKey;
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    const linkParams = t10;
    const dataTestId = isFabricSupported ? "fabric-edit-button" : undefined;
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    let routeType;
    if ($[11] !== isBlogpost || $[12] !== isCompanyHubButton || $[13] !== isEmbeddedContent || $[14] !== isFabricSupported) {
        if (isEmbeddedContent && !isBlogpost) routeType = (0, $1NBp8.EDIT_PAGE_EMBED);
        else {
            if (isCompanyHubButton) routeType = (0, $1NBp8.COMPANY_HUB_EDIT);
            else if (isFabricSupported) routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2);
            else routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
        }
        $[11] = isBlogpost;
        $[12] = isCompanyHubButton;
        $[13] = isEmbeddedContent;
        $[14] = isFabricSupported;
        $[15] = routeType;
    } else routeType = $[15];
    let t11;
    let t12;
    if ($[16] !== currentRouteName || $[17] !== isBlogpost || $[18] !== setEditSource) {
        t11 = ()=>{
            let entryPoint = (0, $7NoF3.PAGE_EDIT_BUTTON_CLICK);
            if (isBlogpost) entryPoint = (0, $7NoF3.BLOG_EDIT_BUTTON_CLICK);
            const isSpaceOverview = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
            if (isSpaceOverview) entryPoint = (0, $7NoF3.SPACE_EDIT_BUTTON_CLICK);
            setEditSource(entryPoint);
            setLocalEditSource(entryPoint);
        };
        t12 = [
            isBlogpost,
            setEditSource,
            currentRouteName,
            setLocalEditSource
        ];
        $[16] = currentRouteName;
        $[17] = isBlogpost;
        $[18] = setEditSource;
        $[19] = t11;
        $[20] = t12;
    } else {
        t11 = $[19];
        t12 = $[20];
    }
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>editButtonRef && (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(editButtonRef.current)?.click();
        $[21] = t13;
    } else t13 = $[21];
    const clickEditPencilButton = t13;
    let t14;
    if ($[22] !== currentRouteName || $[23] !== isBlogpost || $[24] !== setEditSource) {
        t14 = (isClick)=>{
            if (!isClick) {
                let entryPoint_0 = (0, $7NoF3.PAGE_EDIT_SHORTCUT_E);
                if (isBlogpost) entryPoint_0 = (0, $7NoF3.BLOG_EDIT_SHORTCUT_E);
                const isSpaceOverview_0 = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
                if (isSpaceOverview_0) entryPoint_0 = (0, $7NoF3.SPACE_EDIT_SHORTCUT_E);
                setEditSource(entryPoint_0);
                setLocalEditSource(entryPoint_0);
            }
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
        };
        $[22] = currentRouteName;
        $[23] = isBlogpost;
        $[24] = setEditSource;
        $[25] = t14;
    } else t14 = $[25];
    const measureEditButtonClickConversion = t14;
    let t15;
    if ($[26] !== contentId || $[27] !== contentType || $[28] !== currentRouteName || $[29] !== isBlogpost || $[30] !== isEmbeddedContent || $[31] !== isFabricSupported || $[32] !== linkParams || $[33] !== loadEditor || $[34] !== measureEditButtonClickConversion || $[35] !== migrateEPData || $[36] !== routePolicy || $[37] !== routeType || $[38] !== routesContext || $[39] !== spaceKey) {
        t15 = (e)=>{
            measureEditButtonClickConversion(e.isTrusted);
            (0, $74Lca.rememberScrolledPosition)(contentId);
            const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
            const routePolicyPushInNewTab = routePolicy && !routePolicy.willPushInSelf(currentRouteName, contentId, routeType.name, contentId);
            if (!isBlogpost && Boolean(migrateEPData) && routePolicyPushInNewTab) {
                e.preventDefault();
                const navigateToEmbeddedEditor = ()=>{
                    routesContext.push((0, $1NBp8.EDIT_PAGE_EMBED).toUrl(linkParams));
                };
                const navigateToClassicEditor = ()=>{
                    routesContext.push(routeType.toUrl(linkParams));
                };
                migrateEPData(navigateToEmbeddedEditor, navigateToClassicEditor);
            }
            if (details?.href && !routePolicyPushInNewTab) {
                e.preventDefault();
                e.stopPropagation();
                if (!e.isTrusted) routesContext.preloadRoute(details.href);
                loadEditor({
                    contentId: contentId,
                    spaceKey: spaceKey,
                    redirectUrl: details.href,
                    contentType: contentType,
                    isFabricSupported: isFabricSupported,
                    isEmbeddedContent: isEmbeddedContent
                });
            }
        };
        $[26] = contentId;
        $[27] = contentType;
        $[28] = currentRouteName;
        $[29] = isBlogpost;
        $[30] = isEmbeddedContent;
        $[31] = isFabricSupported;
        $[32] = linkParams;
        $[33] = loadEditor;
        $[34] = measureEditButtonClickConversion;
        $[35] = migrateEPData;
        $[36] = routePolicy;
        $[37] = routeType;
        $[38] = routesContext;
        $[39] = spaceKey;
        $[40] = t15;
    } else t15 = $[40];
    routeType;
    const onClickEdit = t15;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const mode = match?.query?.mode;
    let t16;
    if ($[41] !== additionalAnalytics || $[42] !== contentId || $[43] !== contentType || $[44] !== isFabricSupported || $[45] !== isOnEditRoute || $[46] !== mode || $[47] !== searchSessionId) {
        t16 = (e_0, analyticsEvent)=>{
            analyticsEvent.update({
                data: {
                    action: "clicked",
                    actionSubject: "editButton",
                    attributes: {
                        componentVersion: "v2",
                        contentType: contentType,
                        contentId: contentId,
                        isFabricSupported: isFabricSupported,
                        navdexPointType: (0, $56QzY.END),
                        searchSessionId: searchSessionId,
                        ...additionalAnalytics,
                        mode: mode,
                        isOnEditRoute: isOnEditRoute
                    },
                    source: e_0.isTrusted ? "editContentButton" : "editShortcut"
                },
                type: "sendTrackEvent"
            }).fire();
        };
        $[41] = additionalAnalytics;
        $[42] = contentId;
        $[43] = contentType;
        $[44] = isFabricSupported;
        $[45] = isOnEditRoute;
        $[46] = mode;
        $[47] = searchSessionId;
        $[48] = t16;
    } else t16 = $[48];
    const fireClickAnalytics = t16;
    let t17;
    if ($[49] !== contentId || $[50] !== contentType || $[51] !== dataTestId || $[52] !== editShortcutStrings || $[53] !== enforceStorageLimit || $[54] !== fabricEditorEligibility || $[55] !== fireClickAnalytics || $[56] !== intl || $[57] !== isEmbeddedContent || $[58] !== isFabricEligibilityLoading || $[59] !== isFabricSupported || $[60] !== isPopupVisible || $[61] !== linkParams || $[62] !== localEditSource || $[63] !== onClickEdit || $[64] !== onRender || $[65] !== routeType || $[66] !== sendMetrics || $[67] !== sendPrefetchAnalyticsEvent || $[68] !== shouldBlockCreate || $[69] !== spaceKey) {
        t17 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const [convertOnEditExpConfig] = (0, $6mKj3.UNSAFE_noExposureExp)("platform_editor_on_edit_convert");
            let t18;
            if ($[71] !== fabricEditorEligibility || $[72] !== isFabricSupported) {
                t18 = !isFabricSupported && typeof fabricEditorEligibility === "string" && [
                    "SUPPORTED",
                    "SUPPORTED_WITH_MIGRATION"
                ].includes(fabricEditorEligibility);
                $[71] = fabricEditorEligibility;
                $[72] = isFabricSupported;
                $[73] = t18;
            } else t18 = $[73];
            const showConvertPagePopup = t18;
            let t19;
            if ($[74] !== contentId || $[75] !== fireClickAnalytics || $[76] !== isEmbeddedContent || $[77] !== onClickEdit || $[78] !== sendMetrics || $[79] !== sendPrefetchAnalyticsEvent || $[80] !== showConvertPagePopup) {
                t19 = (e_1, analyticsEvent_0)=>{
                    (0, $sD2Tz.resolvePendingPrefetchAnalytics)(contentId, sendPrefetchAnalyticsEvent);
                    if (showConvertPagePopup && (0, $6mKj3.expValEquals)("platform_editor_on_edit_convert", "isEnabled", true)) {
                        e_1.preventDefault();
                        setIsPopupVisible($a4b894acf4b5251f$var$_temp);
                        fireClickAnalytics(e_1, analyticsEvent_0);
                    } else {
                        if (isEmbeddedContent) {
                            const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                            const uniqueKey = observableObject?.object?.uniqueKey;
                            sendMetrics({
                                timestamp: Date.now(),
                                ...uniqueKey ? {
                                    customData: {
                                        uniqueKey: uniqueKey
                                    }
                                } : {}
                            }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_EDIT_CLICK)}`);
                        }
                        fireClickAnalytics(e_1, analyticsEvent_0);
                        onClickEdit(e_1);
                    }
                };
                $[74] = contentId;
                $[75] = fireClickAnalytics;
                $[76] = isEmbeddedContent;
                $[77] = onClickEdit;
                $[78] = sendMetrics;
                $[79] = sendPrefetchAnalyticsEvent;
                $[80] = showConvertPagePopup;
                $[81] = t19;
            } else t19 = $[81];
            const handleButtonClick = t19;
            let t20;
            if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
                t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    id: "edit-button.tooltip",
                    defaultMessage: "Edit"
                });
                $[82] = t20;
            } else t20 = $[82];
            let t21;
            if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
                t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)",
                    spacing: (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "none" : "spacious"
                });
                $[83] = t21;
            } else t21 = $[83];
            let t22;
            if ($[84] !== enforceStorageLimit || $[85] !== handleButtonClick) {
                t22 = enforceStorageLimit(handleButtonClick);
                $[84] = enforceStorageLimit;
                $[85] = handleButtonClick;
                $[86] = t22;
            } else t22 = $[86];
            let t23;
            if ($[87] !== linkParams || $[88] !== routeType || $[89] !== shouldBlockCreate) {
                t23 = shouldBlockCreate ? undefined : routeType.toUrl(linkParams);
                $[87] = linkParams;
                $[88] = routeType;
                $[89] = shouldBlockCreate;
                $[90] = t23;
            } else t23 = $[90];
            let t24;
            if ($[91] !== intl) {
                t24 = intl.formatMessage($a4b894acf4b5251f$var$i18n.editLabel);
                $[91] = intl;
                $[92] = t24;
            } else t24 = $[92];
            let t25;
            if ($[93] !== intl) {
                t25 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    align: "center",
                    weight: "medium",
                    "data-vc": "edit-button-text"
                }, intl.formatMessage($a4b894acf4b5251f$var$i18n.editText));
                $[93] = intl;
                $[94] = t25;
            } else t25 = $[94];
            let t26;
            if ($[95] !== dataTestId || $[96] !== t22 || $[97] !== t23 || $[98] !== t24 || $[99] !== t25) {
                t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4b894acf4b5251f$var$StyledButton, {
                    appearance: "subtle",
                    iconBefore: t21,
                    ref: editButtonRef,
                    onClick: t22,
                    href: t23,
                    "data-test-id": dataTestId,
                    id: "editPageLink",
                    "aria-label": t24
                }, t25);
                $[95] = dataTestId;
                $[96] = t22;
                $[97] = t23;
                $[98] = t24;
                $[99] = t25;
                $[100] = t26;
            } else t26 = $[100];
            let t27;
            if ($[101] !== editShortcutStrings || $[102] !== t26) {
                t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    tag: "span",
                    content: t20,
                    shortcut: editShortcutStrings
                }, t26);
                $[101] = editShortcutStrings;
                $[102] = t26;
                $[103] = t27;
            } else t27 = $[103];
            const button = t27;
            if (isFabricEligibilityLoading) {
                let t28;
                if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
                    t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                        interactionName: "edit-content-button-preloader",
                        size: "small",
                        testId: "edit-content-button-preloader"
                    });
                    $[104] = t28;
                } else t28 = $[104];
                t17 = t28;
                break bb0;
            } else {
                let t28;
                if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
                    t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                        accelerator: (0, $gnkil.EDIT_SHORTCUT),
                        listener: clickEditPencilButton
                    });
                    $[105] = t28;
                } else t28 = $[105];
                let t29;
                if ($[106] !== onRender) {
                    t29 = onRender();
                    $[106] = onRender;
                    $[107] = t29;
                } else t29 = $[107];
                const t30 = showConvertPagePopup && convertOnEditExpConfig.get("isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                    isOpen: isPopupVisible,
                    onClose: ()=>setIsPopupVisible(false),
                    placement: "bottom-start",
                    content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $emYzJ.EditPopupEligibleMigration), {
                            onClickEdit: onClickEdit,
                            contentId: contentId,
                            href: shouldBlockCreate ? undefined : routeType.toUrl(linkParams),
                            contentHash: "",
                            contentType: contentType,
                            spaceKey: spaceKey
                        }),
                    offset: [
                        -34,
                        8
                    ],
                    trigger: (t31)=>{
                        const { ref: ref } = t31;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                            ref: ref
                        }, button);
                    },
                    shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-trueenterprise-e")
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, button);
                let t32;
                if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
                    t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
                    });
                    $[108] = t32;
                } else t32 = $[108];
                let t33;
                if ($[109] !== contentId || $[110] !== isEmbeddedContent || $[111] !== localEditSource || $[112] !== sendPrefetchAnalyticsEvent || $[113] !== spaceKey || $[114] !== t29 || $[115] !== t30) {
                    t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
                        key: contentId,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        isEmbeddedEditor: isEmbeddedContent,
                        editSource: localEditSource,
                        sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent,
                        predictivelyPrefetch: true
                    }, t28, t29, t30, t32);
                    $[109] = contentId;
                    $[110] = isEmbeddedContent;
                    $[111] = localEditSource;
                    $[112] = sendPrefetchAnalyticsEvent;
                    $[113] = spaceKey;
                    $[114] = t29;
                    $[115] = t30;
                    $[116] = t33;
                } else t33 = $[116];
                t17 = t33;
                break bb0;
            }
        }
        $[49] = contentId;
        $[50] = contentType;
        $[51] = dataTestId;
        $[52] = editShortcutStrings;
        $[53] = enforceStorageLimit;
        $[54] = fabricEditorEligibility;
        $[55] = fireClickAnalytics;
        $[56] = intl;
        $[57] = isEmbeddedContent;
        $[58] = isFabricEligibilityLoading;
        $[59] = isFabricSupported;
        $[60] = isPopupVisible;
        $[61] = linkParams;
        $[62] = localEditSource;
        $[63] = onClickEdit;
        $[64] = onRender;
        $[65] = routeType;
        $[66] = sendMetrics;
        $[67] = sendPrefetchAnalyticsEvent;
        $[68] = shouldBlockCreate;
        $[69] = spaceKey;
        $[70] = t17;
    } else t17 = $[70];
    if (t17 !== Symbol.for("react.early_return_sentinel")) return t17;
});
const $a4b894acf4b5251f$export$812a4eda75b35614 = (0, $aXWIB.injectIntl)($a4b894acf4b5251f$var$EditContentButtonComponentInner);
$a4b894acf4b5251f$export$812a4eda75b35614.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onRender: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isEmbeddedContent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isFabricSupported: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
function $a4b894acf4b5251f$var$_temp(prev) {
    return !prev;
}
module.exports["EditContentButtonComponent"] = $a4b894acf4b5251f$export$812a4eda75b35614;

});

parcelRegister("74Lca", function(module, exports) {

var $51ADl = parcelRequire("51ADl");


var $1dnxO = parcelRequire("1dnxO");


var $dpqzw = parcelRequire("dpqzw");


var $b1pBe = parcelRequire("b1pBe");

const $7936391e07f83542$export$69c870891d17d6d0 = (contentId)=>{
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    // root page element
    const page = isNav4Enabled ? document?.getElementById((0, $51ADl.NAV_4_MAIN_CONTENT_ID)) || document.documentElement : document.documentElement;
    // get fabric or classic renderer content id
    const pageContent = document.getElementById((0, $dpqzw.FABRIC_PAGE_CONTENT_ID));
    // if there's no page content, do nothing
    if (!pageContent) return;
    // if the user is already at the top of the page, then no need to scroll
    if (page.scrollTop / page.clientHeight < 0.25) return;
    // save closest scrolled element & contentId to localstorage
    (0, $b1pBe.getClosestScrolledElementIndex)(page, pageContent, contentId);
};
module.exports["rememberScrolledPosition"] = $7936391e07f83542$export$69c870891d17d6d0;

});

parcelRegister("51ADl", function(module, exports) {
const $06488191c40cb6cf$export$cd4d46bdb3670fbb = 'AkMainContent';
module.exports["NAV_4_MAIN_CONTENT_ID"] = $06488191c40cb6cf$export$cd4d46bdb3670fbb;

});

parcelRegister("b1pBe", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $dpqzw = parcelRequire("dpqzw");

const $f44449ceafa69a86$export$1df42b18d7384de5 = (page, pageContent, contentId)=>{
    if (!pageContent) return;
    // grab all of the direct children elements from the rendered content view
    const elementCollection = pageContent.querySelector((0, $dpqzw.RENDERED_CONTENT_SELECTOR))?.children || [];
    // set initial index to -1 in case no closest element is found
    let closestElementIndex = -1;
    // go through all direct children elements and see which is closest to the remembered scroll position
    if (elementCollection.length > 0) {
        const childrenElements = Array.from(elementCollection);
        // calculate scroll position based off of how far a user has scrolled the page minus the distance from the renderer content to the top of the page
        const pageScrollTop = page.scrollTop - pageContent.offsetTop;
        childrenElements.reduce((best, elem, index)=>{
            if (Math.abs(pageScrollTop - elem.offsetTop) < Math.abs(pageScrollTop - best.offsetTop)) {
                closestElementIndex = index;
                return elem;
            } else return best;
        });
    }
    // save the closest element's index to local storage
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION, {
        index: closestElementIndex,
        contentId: contentId
    });
};
module.exports["getClosestScrolledElementIndex"] = $f44449ceafa69a86$export$1df42b18d7384de5;

});

parcelRegister("emYzJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $briGH = parcelRequire("briGH");


var $emb8c = parcelRequire("emb8c");

const $1c786d1286cf45c7$var$i18n = (0, $aXWIB.defineMessages)({
    elligibleMigrationModalTitle: {
        id: "fabric-page-optin-migration.elligible-migration-modal.title",
        defaultMessage: "Time to convert your page"
    },
    elligibleMigrationModalDescription: {
        id: "fabric-page-optin-migration.elligible-migration-modal.description",
        defaultMessage: "This page is compatible with the cloud editor. The legacy editor will be phased out soon, find out more in the <link>announcement</link>."
    },
    elligibleMigrationModalUpdateButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.update-button",
        defaultMessage: "Convert page"
    },
    elligibleMigrationModalCancelButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.cancel-button",
        defaultMessage: "Not now"
    },
    elligibleMigrationModalUnsupported: {
        id: "fabric-page-optin-migration.elligible-migration-modal.unsupported",
        defaultMessage: "This page cannot be converted"
    }
});
const $1c786d1286cf45c7$var$popupContainerStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    font: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
const $1c786d1286cf45c7$var$topMarginStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $1c786d1286cf45c7$var$buttonContainerStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 'space.200'
});
const $1c786d1286cf45c7$var$widthStyle = (0, $ecnYn.xcss)({
    width: '297px'
});
const $1c786d1286cf45c7$export$4e1bf6f2717dc4c8 = ({ onClickEdit: onClickEdit, contentId: contentId, href: href, contentHash: contentHash, contentType: contentType, spaceKey: spaceKey })=>{
    const [popupMessage, setPopupMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalDescription
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [migratePages] = (0, $emb8c.useExperimentalMigratePagesMutation)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'eligibleMigrationModal'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClickConvert = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'eligibleMigrationModalConvertButton',
                source: 'editPopupEligibleMigration'
            }
        }).fire();
        const response = await migratePages({
            variables: {
                contentId: contentId,
                contentHash: contentHash
            }
        });
        const status = (0, $briGH.getStatusFromResponse)(response);
        if (status === '200' || status === '204') {
            const redirectRoute = contentType === 'page' ? (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: contentId
            }) : (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                contentType: 'blog',
                spaceKey: spaceKey,
                contentId: contentId
            }); // perform redirect
            push(redirectRoute);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).PAGE_JUST_CONVERTED, contentId);
        } else {
            setPopupMessage($1c786d1286cf45c7$var$i18n.elligibleMigrationModalUnsupported);
            if (response && 'errors' in response && response.errors) (0, $7Sm4c.markErrorAsHandled)(response.errors);
        }
    }, [
        createAnalyticsEvent,
        migratePages,
        contentId,
        contentHash,
        contentType,
        spaceKey,
        push
    ]);
    if (!isLoggedIn || !href) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$popupContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$widthStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        tagName: "h3",
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle,
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...popupMessage,
        tagName: "p",
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks),
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                    href: "https://community.atlassian.com/forums/Confluence-articles/The-Legacy-Editor-is-being-deprecated-in-Confluence-Cloud-Here-s/ba-p/3046832",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$buttonContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        href: href,
        onClick: onClickEdit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onClickConvert
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalUpdateButton))))));
};
module.exports["EditPopupEligibleMigration"] = $1c786d1286cf45c7$export$4e1bf6f2717dc4c8;

});

parcelRegister("emb8c", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");


var $hBkCm = parcelRequire("hBkCm");

const $b8f7841fb375e78f$export$bff11ed54317b5ef = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ contentId: contentId, contentHash: contentHash })=>`/wiki/rest/api/content/${contentId}/convert?hash=${contentHash}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON,
            'X-Requested-With': 'XMLHttpRequest'
        },
        parseResult: (response)=>({
                experimentalMigratePages: {
                    status: String(response.status)
                }
            }),
        parseResponseOnSuccess: async (response)=>{
            return {
                status: response.status
            };
        },
        parseResponseOnError: async (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                status: error.response.status
            };
            throw error;
        },
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useExperimentalMigratePagesMutation"] = $b8f7841fb375e78f$export$bff11ed54317b5ef;

});

parcelRegister("ca2z9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2HZwz = parcelRequire("2HZwz");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");

const $a70c768defde6626$var$UseFabricEligibilityMigrationQuery = (0, $2HZwz.default);
const $a70c768defde6626$export$848562a07f990254 = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { contentId: contentId, isFabricSupported: isFabricSupported } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const shouldFetch = isFabricSupported === false;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            fetchPolicy: "cache-first",
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($a70c768defde6626$var$UseFabricEligibilityMigrationQuery, {
        ...t1,
        __callerPackage__: "@confluence/edit-button"
    });
    let t2;
    if ($[2] !== contentId || $[3] !== createAnalyticsEvent) {
        t2 = (t3)=>{
            const { reason: reason } = t3;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "failed",
                    actionSubject: "fabricEditorEligibilityQuery",
                    attributes: {
                        contentId: contentId,
                        reason: reason
                    },
                    source: "editContentButton"
                }
            }).fire();
        };
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    const fireErrorEvent = t2;
    let t3;
    let t4;
    if ($[5] !== error || $[6] !== fireErrorEvent) {
        t3 = ()=>{
            if (error) fireErrorEvent({
                reason: "APOLLO_ERROR"
            });
        };
        t4 = [
            error,
            fireErrorEvent
        ];
        $[5] = error;
        $[6] = fireErrorEvent;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    bb0: {
        if (!shouldFetch) {
            let t6;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    fabricEditorEligibility: null,
                    contentHash: null,
                    isFabricEligibilityLoading: false
                };
                $[9] = t6;
            } else t6 = $[9];
            t5 = t6;
            break bb0;
        }
        if (!data && shouldFetch) {
            let t6;
            if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[10] = t6;
            } else t6 = $[10];
            t5 = t6;
            break bb0;
        }
        if (!data && loading) {
            let t6;
            if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[11] = t6;
            } else t6 = $[11];
            t5 = t6;
            break bb0;
        }
        if (data) {
            const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
            const fabricEditorEligibility = metadataFrontend?.fabricEditorEligibility;
            const contentHash = metadataFrontend?.contentHash;
            let t6;
            if ($[12] !== contentHash || $[13] !== fabricEditorEligibility) {
                t6 = {
                    fabricEditorEligibility: fabricEditorEligibility,
                    contentHash: contentHash,
                    isFabricEligibilityLoading: false
                };
                $[12] = contentHash;
                $[13] = fabricEditorEligibility;
                $[14] = t6;
            } else t6 = $[14];
            t5 = t6;
            break bb0;
        }
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                fabricEditorEligibility: null,
                contentHash: null,
                isFabricEligibilityLoading: false
            };
            $[15] = t6;
        } else t6 = $[15];
        t5 = t6;
    }
    return t5;
};
module.exports["useFabricEligibilityMigrationQuery"] = $a70c768defde6626$export$848562a07f990254;

});

parcelRegister("2HZwz", function(module, exports) {
/**
 * @generated SignedSource<<827507a6d415f89f9ea888951476199b>>
 * @relayHash ec4bb4fc4b91bdd22636b8cd5a8459f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288
const $41339af49efc6ee3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorEligibility"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentHash"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ec4bb4fc4b91bdd22636b8cd5a8459f5",
            "id": "1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288",
            "metadata": {},
            "name": "useFabricEligibilityMigrationQuery",
            "operationKind": "query",
            "text": "query useFabricEligibilityMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{frontend{fabricEditorEligibility,contentHash}}}}}"
        }
    };
}();
$41339af49efc6ee3$var$node.hash = "204d8fbd9ab341cec958fee25e721167";
var $41339af49efc6ee3$export$2e2bcd8739ae039 = $41339af49efc6ee3$var$node;
module.exports["default"] = $41339af49efc6ee3$export$2e2bcd8739ae039;

});

parcelRegister("7mHcA", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2zRSX = parcelRequire("2zRSX");


var $gkjo6 = parcelRequire("gkjo6");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");

let $6feb6b3d360f0331$var$onMigrationSuccess = ()=>{};
let $6feb6b3d360f0331$var$onMigrationFailure = ()=>{};
const $6feb6b3d360f0331$export$a48339a192545f1f = (contentId, skipOnLoadQuery)=>{
    const $ = (0, $frIzR.c)(27);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent) {
        t0 = (t1)=>{
            const { action: action, actionSubjectId: actionSubjectId, withMigration: withMigration, error: error } = t1;
            return createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: action,
                    actionSubject: "ncsMigrationQuery",
                    actionSubjectId: actionSubjectId,
                    source: "embeddedPageViewScreen",
                    object: {
                        id: contentId,
                        type: "page"
                    },
                    attributes: {
                        withMigration: withMigration,
                        error: error
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const trackMigrationEvent = t0;
    let t1;
    if ($[3] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    let t3;
    if ($[5] !== trackMigrationEvent) {
        t2 = (data)=>{
            if (data?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: true
            });
            else trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: false
            });
        };
        t3 = (err)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnLoad",
                error: err.message
            });
        };
        $[5] = trackMigrationEvent;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    let t4;
    if ($[8] !== skipOnLoadQuery || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
        t4 = {
            variables: t1,
            fetchPolicy: "network-only",
            skip: skipOnLoadQuery,
            onCompleted: t2,
            onError: t3
        };
        $[8] = skipOnLoadQuery;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    const epMigrationOnLoad = (0, $jMyy4.useQueryInterop)((0, $gkjo6.default), {
        ...t4,
        __callerPackage__: "@confluence/edit-button"
    });
    let t5;
    if ($[13] !== contentId) {
        t5 = {
            contentId: contentId
        };
        $[13] = contentId;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== trackMigrationEvent) {
        t6 = (err_0)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnEditClick",
                error: err_0?.message
            });
            $6feb6b3d360f0331$var$onMigrationFailure(err_0);
        };
        $[15] = trackMigrationEvent;
        $[16] = t6;
    } else t6 = $[16];
    const [migrateData, t7] = (0, $lvOsp.useLazyQueryInterop)((0, $2zRSX.default), {
        variables: t5,
        fetchPolicy: "network-only",
        onCompleted: (data_0)=>{
            if (data_0?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: true
                });
                $6feb6b3d360f0331$var$onMigrationSuccess(onClickData);
            } else {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: false
                });
                $6feb6b3d360f0331$var$onMigrationFailure();
            }
        },
        onError: t6,
        __callerPackage__: "@confluence/edit-button"
    });
    const { data: t8, loading: onClickLoading, error: onClickError } = t7;
    const onClickData = t8;
    let t9;
    if ($[17] !== migrateData) {
        t9 = (t10, t11)=>{
            const onSuccess = t10 === undefined ? $6feb6b3d360f0331$var$_temp : t10;
            const onFailure = t11 === undefined ? $6feb6b3d360f0331$var$_temp2 : t11;
            $6feb6b3d360f0331$var$onMigrationSuccess = onSuccess;
            $6feb6b3d360f0331$var$onMigrationFailure = onFailure;
            migrateData();
        };
        $[17] = migrateData;
        $[18] = t9;
    } else t9 = $[18];
    const migrateEPData = t9;
    let t10;
    if ($[19] !== migrateEPData || $[20] !== onClickData || $[21] !== onClickError || $[22] !== onClickLoading) {
        t10 = {
            migrateEPData: migrateEPData,
            data: onClickData,
            loading: onClickLoading,
            error: onClickError
        };
        $[19] = migrateEPData;
        $[20] = onClickData;
        $[21] = onClickError;
        $[22] = onClickLoading;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== epMigrationOnLoad || $[25] !== t10) {
        t11 = {
            epMigrationOnLoad: epMigrationOnLoad,
            epMigrationOnClick: t10
        };
        $[24] = epMigrationOnLoad;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
};
function $6feb6b3d360f0331$var$_temp() {}
function $6feb6b3d360f0331$var$_temp2() {}
module.exports["useEmbeddedMigrationQuery"] = $6feb6b3d360f0331$export$a48339a192545f1f;

});

parcelRegister("2zRSX", function(module, exports) {
/**
 * @generated SignedSource<<3f1c6cd6494336472f6b32776e1b4252>>
 * @relayHash 8ce6c444a2fa7276cb4da3d1a791d300
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b36d62c169e4fc5c39a3306da79a54ff311e294e3ad79fbb21c36f48abdc74b
const $a67fcf7b0c351cc5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embeddedWithMigration"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ce6c444a2fa7276cb4da3d1a791d300",
            "id": "2b36d62c169e4fc5c39a3306da79a54ff311e294e3ad79fbb21c36f48abdc74b",
            "metadata": {},
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "operationKind": "query",
            "text": "query useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery($contentId:ID!){content(id:$contentId){nodes{id,type,metadata{frontend{embeddedWithMigration}}}}}"
        }
    };
}();
$a67fcf7b0c351cc5$var$node.hash = "e811ca917e234d313519ff2281e9d6fc";
var $a67fcf7b0c351cc5$export$2e2bcd8739ae039 = $a67fcf7b0c351cc5$var$node;
module.exports["default"] = $a67fcf7b0c351cc5$export$2e2bcd8739ae039;

});

parcelRegister("gkjo6", function(module, exports) {
/**
 * @generated SignedSource<<d43294402b898c3229e7aba801086cef>>
 * @relayHash 3b2300539134eec5a57f18f298c307e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3fa39827a54818a9014acf891b0b162dcb6f4a289ff487ce4c67d552c5d850ec
const $7dbead30693bf664$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embeddedWithMigration"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3b2300539134eec5a57f18f298c307e4",
            "id": "3fa39827a54818a9014acf891b0b162dcb6f4a289ff487ce4c67d552c5d850ec",
            "metadata": {},
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "operationKind": "query",
            "text": "query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,type,metadata{frontend{embeddedWithMigration}}}}}"
        }
    };
}();
$7dbead30693bf664$var$node.hash = "226895c47be9fed079eb4901c8267e39";
var $7dbead30693bf664$export$2e2bcd8739ae039 = $7dbead30693bf664$var$node;
module.exports["default"] = $7dbead30693bf664$export$2e2bcd8739ae039;

});

parcelRegister("bjZbA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8tdj3 = parcelRequire("8tdj3");


var $1qfLF = parcelRequire("1qfLF");


var $ep3mz = parcelRequire("ep3mz");


var $iXzFq = parcelRequire("iXzFq");

const $b9c78150b710374f$export$692138f5b3745b91 = ()=>{
    const [{ contentId: contentId, contentType: contentType, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const handleClick = ()=>{
        if (!contentId || !contentType || !spaceKey) return;
        const url = (0, $iXzFq.getUrlForContentType)({
            contentType: contentType,
            contentId: contentId,
            spaceKey: spaceKey,
            redirectToEditor: false
        });
        if (!url) return;
        window.open(url, '_blank');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        label: "Open in new window",
        onClick: handleClick,
        testId: "loom-external-open-button"
    });
};
module.exports["LoomExternalOpenButton"] = $b9c78150b710374f$export$692138f5b3745b91;

});


//# sourceMappingURL=DetailsPanelHeaderIcon.78f0d9c8.js.map
